import useEditSize from 'modules/products/hooks/use-edit-size';
import {SizeProps, translatedSizeProps} from 'modules/products/types';
import productsKeys from 'modules/products/util/products-keys';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditSize: React.FC = () => {
  const {id, sizeId} = useParams();
  const {getInput, getPriceInput} = useFormInputs<SizeProps>();

  return (
    <Edition
      border
      detailsUrl={`/products/${id}/sizes/${sizeId}`}
      translationKey={translatedSizeProps}
      onSubmit={() => useEditSize(id!, sizeId!)}
      inputs={[getInput({name: 'name'}), getPriceInput({name: 'price'})]}
      queryKey={productsKeys.sizeDetails(id!, sizeId!)}
    />
  );
};

export default EditSize;
